export enum Plan {
  Free = 'free',
  Pro = 'pro',
  Unlimited = 'unlimited',
}

export const PLAN_HIERARCHY: Record<Plan, number> = {
  [Plan.Free]: 0,
  [Plan.Pro]: 1,
  [Plan.Unlimited]: 2,
};
